import { type TableColumnDisplayValues } from '../../../types';
import { formatNumber } from '../../Pipes/numberPipes';
import { Svgicon } from 'components/Svgicon/Svgicon';
import { type FC } from 'react';
import { isTablet } from 'services/mobile';

export type AggregationBoxProps = {
  name: string,
  value: number,
};

export type CapitalAccountsNumbersAggregationChartProps = {
  values: TableColumnDisplayValues,
};
const getIconId = (name: string) => {
  if (name === 'Contribution (Net due/advance)') {
    return 'arrow-up-1f';
  } else {
    return 'arrow-down-1f';
  }
};

const AggregationBox: FC<AggregationBoxProps> = ({
  name,
  value,
}) => <div className=' flex w-full flex-col gap-[0.25rem] overflow-hidden rounded-full bg-white-999 p-[0.5rem] shadow-card-x3 ms:basis-[calc((100%-3rem)/4)] ms:rounded-medium ms:p-[1rem]'>
  <div className='flex items-center overflow-hidden'>
    {name === 'Net Gain/(Loss)' || name === 'Partners capital (NAV)' ? null : <Svgicon className='size-[1.25rem] min-w-[1.25rem]' id={getIconId(name)} />}
    <p className='m-0 truncate text-font-3 font-normal'>
      {name}
    </p>
  </div>
  <p className='m-0 text-title-4 font-semibold'>
    {formatNumber(value, 0)}
  </p>
</div>;

export const CapitalAccountsNumbersAggregationChart: FC<
CapitalAccountsNumbersAggregationChartProps> = ({
  values,
}) => {
  if (isTablet()) {
    return <div className='flex w-full flex-col items-center gap-[0.75rem]'>
      <div className='flex w-full gap-[0.75rem]'>
        <AggregationBox
          name={'Contribution (Net due/advance)'}
          value={values?.contribution + values?.contributionDue}
        />
        <AggregationBox
          name={'Distribution & WHT'}
          value={values?.distribution + values?.distributionWth}
        />
      </div>
      <div className='flex w-full gap-[0.75rem]'>
        <AggregationBox
          name={'Net Gain/(Loss)'}
          value={values?.unrealizedGainLoss + values?.realizedGainLoss + values?.other}
        />
        <AggregationBox
          name={'Partners capital (NAV)'}
          value={values?.nav}
        />
      </div>
    </div>;
  }

  return <div className='flex w-full flex-row items-center gap-[0.125rem]'>
    <AggregationBox
      name={'Contribution (Net due/advance)'}
      value={values?.contribution + values?.contributionDue}
    />
    <span className='text-title-4 text-black-400'>+</span>
    <AggregationBox
      name={'Distribution & WHT'}
      value={values?.distribution + values?.distributionWth}
    />
    <span className='text-title-4 text-black-400'>+</span>
    <AggregationBox
      name={'Net Gain/(Loss)'}
      value={values?.unrealizedGainLoss + values?.realizedGainLoss + values?.other}
    />
    <span className='text-title-4 text-black-400'>=</span>
    <AggregationBox
      name={'Partners capital (NAV)'}
      value={values?.nav}
    />
  </div>;
};
